import { render, staticRenderFns } from "./useGroup.vue?vue&type=template&id=16b0e836&"
import script from "./useGroup.vue?vue&type=script&lang=js&"
export * from "./useGroup.vue?vue&type=script&lang=js&"
import style0 from "./useGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "useGroup.vue"
export default component.exports